"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Position2 = exports.Corner = exports.Position = exports.TryPosition = void 0;
var TryPosition;
(function (TryPosition) {
    TryPosition[TryPosition["Left"] = 0] = "Left";
    TryPosition[TryPosition["Right"] = 1] = "Right";
    TryPosition[TryPosition["LeftBottom"] = 2] = "LeftBottom";
    TryPosition[TryPosition["RightBottom"] = 3] = "RightBottom";
})(TryPosition = exports.TryPosition || (exports.TryPosition = {}));
function Position(against, element, callBack) {
    var againstPosition = against.getBoundingClientRect();
    var windowPosition = document.body.getBoundingClientRect();
    var dropdownPosition = element.getBoundingClientRect();
    var result = {
        Left: 0,
        Top: 0,
    };
    var bottom = againstPosition.top - dropdownPosition.height;
    var top = againstPosition.bottom;
    result.Top = top;
    if (againstPosition.bottom + dropdownPosition.height > windowPosition.height) {
        result.Top = bottom;
    }
    var right = againstPosition.left - dropdownPosition.width;
    result.Left = againstPosition.left;
    if (againstPosition.right + dropdownPosition.width > windowPosition.width) {
        result.Left = right + 10;
        right = againstPosition.right;
    }
    else if (againstPosition.right - dropdownPosition.width >= 0) {
        result.Left = againstPosition.right - 15;
    }
    if (callBack) {
        callBack(result);
    }
}
exports.Position = Position;
var Corner;
(function (Corner) {
    Corner[Corner["TopLeft"] = 0] = "TopLeft";
    Corner[Corner["TopRight"] = 1] = "TopRight";
    Corner[Corner["BottomLeft"] = 2] = "BottomLeft";
    Corner[Corner["BottomRight"] = 3] = "BottomRight";
})(Corner = exports.Corner || (exports.Corner = {}));
function Position2(parentOptions, childOptions, defender) {
    if (defender === void 0) { defender = 0; }
    var parent = parentOptions.Element.getBoundingClientRect();
    var child = childOptions.Element.getBoundingClientRect();
    var windowPosition = document.body.getBoundingClientRect();
    defender++;
    // exit out of recursive function - nothing fits
    if (defender > 4) {
        return;
    }
    var testPosition = function (posLeft, posTop, fail) {
        childOptions.Element.style.top = posTop + "px";
        childOptions.Element.style.left = posLeft + "px";
        var test = childOptions.Element.getBoundingClientRect();
        var fL = false;
        var fT = false;
        if (test.right > windowPosition.right || test.left < windowPosition.left) {
            fL = true;
        }
        if (test.bottom > windowPosition.bottom || test.top < windowPosition.top) {
            fT = true;
        }
        if (fL || fT) {
            fail(fL, fT);
        }
    };
    var left = 0;
    var top = 0;
    // left
    if (parentOptions.Position === Corner.TopLeft || parentOptions.Position === Corner.BottomLeft) {
        left = parent.left;
        if (childOptions.Position === Corner.TopRight || childOptions.Position === Corner.BottomRight) {
            left = parent.left - child.width;
        }
    }
    if (parentOptions.Position === Corner.TopRight || parentOptions.Position === Corner.BottomRight) {
        left = parent.right;
        if (childOptions.Position === Corner.TopRight || childOptions.Position === Corner.BottomRight) {
            left = parent.right - child.width;
        }
    }
    // now top;
    if (parentOptions.Position === Corner.TopLeft || parentOptions.Position === Corner.TopRight) {
        top = parent.top;
        if (childOptions.Position === Corner.BottomLeft || childOptions.Position === Corner.BottomRight) {
            top = parent.top - child.height;
        }
    }
    if (parentOptions.Position === Corner.BottomLeft || parentOptions.Position === Corner.BottomRight) {
        top = parent.bottom;
        if (childOptions.Position === Corner.BottomLeft || childOptions.Position === Corner.BottomRight) {
            top = parent.bottom - child.height;
        }
    }
    // try and postition
    testPosition(left, top, function (failLeft, failTop) {
        // now reverse;
        if (failLeft) {
            if (childOptions.Position === Corner.TopLeft) {
                childOptions.Position = Corner.TopRight;
            }
            else if (childOptions.Position === Corner.TopRight) {
                childOptions.Position = Corner.TopLeft;
            }
            else if (childOptions.Position === Corner.BottomLeft) {
                childOptions.Position = Corner.BottomRight;
                parentOptions.Position = Corner.TopRight;
            }
            else if (childOptions.Position === Corner.BottomRight) {
                childOptions.Position = Corner.BottomLeft;
            }
        }
        if (failTop) {
            if (childOptions.Position === Corner.BottomLeft) {
                parentOptions.Position = Corner.BottomLeft;
                childOptions.Position = Corner.TopLeft;
            }
            else if (childOptions.Position === Corner.BottomRight) {
                childOptions.Position = Corner.TopRight;
            }
            else if (childOptions.Position === Corner.TopLeft) {
                childOptions.Position = Corner.BottomLeft;
                parentOptions.Position = Corner.BottomRight;
            }
            else if (childOptions.Position === Corner.TopRight) {
                childOptions.Position = Corner.BottomRight;
            }
        }
        Position2(parentOptions, childOptions, defender);
    });
}
exports.Position2 = Position2;
